export default __webpack_public_path__ + "static/media/WeatherDashboard.1757d75a.jpg";